<template>
  <el-dialog
    top="15vh"
    class="device-edit__dialog"
    :title="$t('Device.remoteControl')"
    width="800px"
    :close-on-click-modal="false"
    :before-close="close"
    :visible.sync="visible"
  >
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="auto"
      size="small"
      label-suffix=": "
    >
      <el-form-item :label="server.name" v-for="server in serversList" :key="server.identifier">
        <template v-if="server.inputData.length > 0">
          <div
            v-for="(property, i2) in server.inputData"
            :key="property.identifier"
            :id="property.identifier"
          >
            <div
              v-if="property.dataType === 'enum' || property.dataType === 'bool'"
              style="margin-bottom: 8px;display: flex"
            >
              <span style="margin-right: 8px;min-width: 120px">{{ property.name }}:</span>
              <Select
                :options="objToArray(property.specs.enumDesc)"
                v-model="propertyList[i2]"
              ></Select>
              <hl-button
                :disabled="info.online !== 'online'"
                style="margin-left: 8px"
                type="secondary"
                @click="
                  downCmd(
                    server.cmd,
                    property.identifier,
                    property.operateType || 'holdingRegister',
                    property.allocated,
                    1,
                    propertyList[i2]
                  )
                "
                >{{ $t('Device.downCmd') }}</hl-button
              >
            </div>
            <div v-else style="margin-bottom: 8px;display: flex">
              <div style="margin-right: 8px;min-width: 120px">{{ property.name }}:</div>
              <el-input v-model="propertySecondaryList[i2]"></el-input>
              <hl-button
                :disabled="info.online !== 'online'"
                style="margin-left: 8px"
                type="secondary"
                @click="
                  downCmd(
                    server.cmd,
                    property.identifier,
                    property.operateType || 'holdingRegister',
                    property.allocated,
                    1,
                    propertySecondaryList[i2]
                  )
                "
                >{{ $t('Device.downCmd') }}</hl-button
              >
            </div>
          </div>
        </template>
      </el-form-item>
    </el-form>
    <!--    <div slot="footer" class="edit-footer">-->
    <!--      <hl-button type="border" @click="close">{{ $t('Common.cancel') }}</hl-button>-->
    <!--      <hl-button @click="save" :loading="loading">{{ $t('Common.save') }}</hl-button>-->
    <!--    </div>-->
  </el-dialog>
</template>

<script>
let client = null
let timer = null
import Select from '@/components/CommonForm/Select'
import { createMqttClient, topicPrefix } from '@/utils/mqttClient'
import { decToBi, dec2hex, dexToHEX } from '@/utils/utils'
import i18n from '@/locales/index'
const mqttState = {
  loading: 'loading',
  fail: 'fail',
  success: 'success'
}
const mqttStateNameEnum = {
  loading: i18n.t('Common.loading'),
  fail: i18n.t('Common.connFail'),
  success: i18n.t('Common.connSuccess')
}
export default {
  name: 'RemoteControl',
  components: { Select },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    productKey: {
      type: String,
      default: ''
    },
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {},
      productList: [],
      rules: {
        // name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        code: [{ required: true, message: this.$t('Device.deviceCode'), trigger: 'blur' }],
        factoryArea: [{ required: true, message: this.$t('Device.factoryArea'), trigger: 'blur' }],
        productKey: [{ required: true, message: this.$t('Device.productModel'), trigger: 'change' }]
      },
      loading: false,
      serversList: [],
      propertyList: [],
      propertySecondaryList: [],
      downTopic: '',
      upTopic: ''
    }
  },
  created() {
    // if (this.productKey) {
    //   this.getServersList()
    // }
  },
  mounted() {
    if (this.info.communicationCode) {
      this.connectMqttService()
    }
    if (this.productKey) {
      this.getServersList()
    }
  },
  methods: {
    dec2hex, //10进制转为16进制
    dexToHEX,

    checkForm() {
      let pass = true
      this.$refs.form.validate((valid) => {
        pass = valid
      })
      return pass
    },
    connectMqttService() {
      client = createMqttClient(
        this,
        onMessage(this),
        onConnect(this),
        onError(this),
        this.info.communicationCode
      )
    },
    downCmd(cmdInfo, identifier, regisetrType, address, num, value) {
      console.log('cmdInfo', cmdInfo)
      console.log('regisetrType', regisetrType)
      console.log('address', address)
      console.log('num', num)
      console.log('value', value)
      this.downTopic = `${topicPrefix}mqtt/${this.info.communicationCode}/down`

      // console.log(this.form)
      let cmd = {}
      if (cmdInfo === 'config') {
        let params = {}
        params[identifier] = Number(value)
        cmd = {
          cmd: cmdInfo,
          params
        }
      } else {
        if (regisetrType === null || address === null) {
          this.$message.warning(`${this.$t('Device.downCmdTips')}`)
          return
        } else if (value === null || value === '' || value === undefined) {
          this.$message.warning(`${this.$t('Device.downCmdTips2')}`)
          return
        }
        if (regisetrType === 'holdingRegister') {
          cmd = {
            cmd: cmdInfo,
            params: {
              holdingRegister: [
                {
                  start: address,
                  num: num,
                  // data: this.dec2hex(value, 4)
                  data: this.dexToHEX(value, 4)
                }
              ]
            }
          }
        }
      }

      console.log('cmd', cmd)
      client.publish(this.downTopic, JSON.stringify(cmd))
      this.$store.commit('SET_CMD_CONTENT', cmd)
      // client.subscribe(this.upTopic)
      this.loading = true
      timer = setTimeout(() => {
        this.loading = false
      }, 60000)
    },
    objToArray(obj) {
      let initArr = obj ? Object.entries(obj) : []
      let arr = []
      initArr.map((item) => {
        let newObj = {
          code: item[0],
          name: item[1]
        }
        arr.push(newObj)
      })
      return arr
    },
    getServersList() {
      const params = {
        productKey: this.productKey
        // code: this.info.code
      }
      const api = this.$api.common.tsl_servers_list
      let shadowList = []
      this.$ajax
        .get(this.$api.iceDevice.iceDevice_remote_control, { deviceId: this.info.id })
        .then((res1) => {
          shadowList = res1.data
          this.$ajax.get(api, params).then((res) => {
            if (res.success) {
              this.serversList = res.data
              let list = []
              let list2 = []
              res.data.forEach((item1) => {
                if (item1.inputData.length > 0) {
                  item1.inputData.forEach((item2, i2) => {
                    if (
                      res1.data[item2.identifier] &&
                      (item2.dataType === 'enum' || item2.dataType === 'bool')
                    ) {
                      list[i2] = res1.data[item2.identifier]
                      // list.push(res1.data[item2.identifier])
                    } else if (
                      res1.data[item2.identifier] &&
                      item2.dataType !== 'enum' && item2.dataType !== 'bool'
                    ) {
                      list2[i2] = res1.data[item2.identifier]
                      // list2.push(res1.data[item2.identifier])
                    }
                  })
                }
              })
              this.propertyList = list
              this.propertySecondaryList = list2
            } else {
              this.serversList = []
            }
          })
        })
    },
    close() {
      this.$emit('update:visible', false)
    }
  }
}
function onConnect(self) {
  return function() {
    self.mqttConnectState = mqttState.success
  }
}
function onError(self) {
  return function() {
    self.mqttConnectState = mqttState.fail
  }
}
function onMessage(self) {
  return function(topic, message) {
    let payload
    try {
      payload = JSON.parse(message.toString(), null, 2)
    } catch (err) {
      /* eslint-disable-next-line */
      payload = {}
    }
    // if (payload.cmd === self.selectedCmd.identifier) {
    //   self.receiveMessagList.push(payload)
    //   client.unsubscribe(self.upTopic)
    //   timer && clearTimeout(timer)
    //   self.loading = false
    // }
  }
}
</script>

<style scoped></style>
